import { getRuntime } from '../runtime';
import { PlatformCapabilityUnsupportedError } from '../errors';
import { shellBridge, unwrapBridgeResult } from '../electron/bridge';

/** Emergency exit: intentionally bypass renderer guards; main owns bounded shutdown. */
export async function quitIsolatedApp(): Promise<void> {
  const { kind, capabilities } = getRuntime();
  if (!capabilities.appExit) throw new PlatformCapabilityUnsupportedError('appExit', kind);
  unwrapBridgeResult('shell', await shellBridge().quit({ reason: 'operator-exit' }));
}
